// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css"; // Import global styles
import { BrowserRouter } from "react-router-dom";
import { analytics } from "./firebase"; // Initialize Firebase Analytics

// Log analytics initialization (auto-tracks page views)
if (analytics) {
  console.log("Firebase Analytics initialized");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
